import axios from 'axios';
import { handleError } from '@/shared/services/api';

export default {
  baseUrl() {
    return `${window.api_url}/organization/reviewers`;
  },

  async index(filters) {
    return axios
      .get(this.baseUrl(), {
        params: filters,
      })
      .catch(handleError);
  },
};
